import { all } from "redux-saga/effects";
import { loginWatcher } from "./actions/auth/saga";
import { dashboardWatcher } from "./actions/dashboard/saga";
import { categoriesWatcher } from "./actions/categories/saga";
import { employeesWatcher } from "./actions/employees/saga";
import { reportsWatcher } from "./actions/reports/saga";
import { expensesWatcher } from "./actions/expenses/saga";
import { tripsWatcher } from "./actions/trips/saga";
import { cardsWatcher } from "./actions/cards/saga";
import { advancesWatcher } from "./actions/advances/saga";
import { companySettingWatcher } from "./actions/companySettings/saga";
import { disputesWatcher } from "./actions/disputes";
import { beneficiaryWarcher } from "./actions/beneficiary/sage";

export function* rootSagas() {
  yield all([
    loginWatcher(),
    dashboardWatcher(),
    categoriesWatcher(),
    reportsWatcher(),
    expensesWatcher(),
    tripsWatcher(),
    cardsWatcher(),
    advancesWatcher(),
    employeesWatcher(),
    companySettingWatcher(),
    disputesWatcher(),
    beneficiaryWarcher()
  ]);
}
